import React, { useEffect, useRef } from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import Stepper from '@mui/joy/Stepper';
import Step from '@mui/joy/Step';
import StepIndicator from '@mui/joy/StepIndicator';
import { Date, Radio } from '../../InputField2';
import { Formik } from 'formik';
import yup from '../../../modules/common/yup';
import moment from 'moment';

const monthLater = (month) => (date) => {
  return moment(date).add(month, 'month').format('YYYY/MM/DD');
};
const yearLaterEnd = (year) => (date) => {
  return moment(date).add(year, 'year').endOf('year').format('YYYY/MM/DD');
};
const questionList = [
  { step: 0, number: 1, text: '相続発生日はいつですか', type: 'date' },
  {
    step: 1,
    number: 2,
    text: '相続放棄または限定承認する人はいますか？',
    type: 'choice',
    disabledDocumentNumbers: { 0: [1] },
  },
  {
    step: 2,
    number: 3,
    text: '相続人が複数である（受遺者を含む）',
    type: 'choice',
    disabledDocumentNumbers: { 0: [6, 7] },
    disabledQuestionNumbers: { 0: [4, 5] },
  },
  {
    step: 3,
    number: 4,
    text: '遺産分割方法を、ひとつ選択してください',
    type: 'list',
    data: [
      '遺産分割協議を行う',
      '公正証書遺言や自筆証書遺言書保管制度を利用した遺言がある',
      '相続人は１人',
    ],

    disabledDocumentNumbers: { 1: [7] },
    disabledQuestionNumbers: { 1: [5] },
  },
  {
    step: 4,
    number: 5,
    text: '所得税の申告や、医療費控除の還付請求などで<br class="pc-only" />準確定申告をする予定ですか',
    type: 'choice',
    disabledDocumentNumbers: { 0: [2] },
  },
  {
    step: 5,
    number: 6,
    text: '相続する不動産について教えてください',
    type: 'list',
    data: [
      '相続税申告期限より前に、不動産の売却予定がある',
      '相続税申告後に、不動産の売却予定がある',
      '売却予定の不動産はない',
    ],
    disabledDocumentNumbers: { 0: [9, 11, 12] },
    disabledQuestionNumbers: { 0: [8, 9] },
  },
  {
    step: 6,
    number: 7,
    text: '相続人について、該当するものがあれば選択してください',
    type: 'multiple',
    data: [
      '法定相続情報一覧図を作成する',
      '障がい者',
      '未成年',
      '被成年後見人',
    ],
    disabledDocumentNumbers: { 1: [11, 12], 0: [9] },
  },
  {
    step: 7,
    number: 8,
    text: '相続財産に金融資産がある場合、<br class="pc-only" />該当するものをお選びください',
    type: 'multiple',
    data: [
      '預貯金',
      '有価証券',
      '信託銀行預かりの端株',
      '配当期待権',
      '未収配当金',
      '非上場株式',
      { label: '出資金', helper: '信用金庫や生協など' },
      '名義預金・名義証券',
    ],
    disabledDocumentNumbers: { 1: [11], 0: [12] },
  },

  {
    step: 8,
    number: 9,
    text: '相続財産に保険がある場合、<br class="pc-only" />該当するものをお選びください',
    type: 'multiple',
    data: [
      '死亡保険金',
      { label: '生命保険に関する権利', helper: '年金等' },
      '入院保険',
      '火災保険',
      '名義保険',
    ],
    disabledDocumentNumbers: { 1: [11], 0: [12] },
  },
  {
    step: 9,
    number: 10,
    text: '小規模宅地等の特例対象で<br class="pc-only" />該当するものがあれば選択してください',
    type: 'multiple',
    data: [
      '家なき子特例の対象となる相続',
      '被相続人は老人ホームに入居していた',
      '特定同族会社の事業用宅地',
      '貸付事業用宅地',
    ],
    disabledDocumentNumbers: { 1: [11], 0: [12] },
  },
];
const documentList = [
  {
    number: 0,
    text: '被相続人情報の戸籍・住民票の除票の収集',
    timing: monthLater(10),
  },
  {
    number: 1,
    text: '相続放棄・限定承認する場合の手続き',
    timing: monthLater(3),
  },
  {
    number: 2,
    text: '準確定申告をする',
    timing: monthLater(4),
  },
  {
    number: 3,
    text: '財産の資料収集',
    timing: monthLater(10),
  },
  {
    number: 4,
    text: '債務・葬儀費用の資料収集',
    timing: monthLater(10),
  },
  {
    number: 5,
    text: '土地の評価を行う',
    timing: '期限はないが早め',
  },
  {
    number: 6,
    text: '遺産分割協議を行う',
    timing: '期限はないが早め',
  },
  {
    number: 7,
    text: '遺言の検認調書もしくは検認済証明書を取得',
    timing: monthLater(10),
  },
  {
    number: 8,
    text: '財産の名義変更・相続登記',
    timing: monthLater(10),
  },
  {
    number: 9,
    text: '不動産売却などの資産整理',
    timing: monthLater(10),
  },
  {
    number: 10,
    text: '相続税申告と納付',
    timing: monthLater(10),
  },
  {
    number: 11,
    text: '不動産売却などの資産整理',
    timing: monthLater(46),
    remark: '※取得費加算とマイホーム特例',
  },
  {
    number: 12,
    text: '不動産売却などの資産整理',
    timing: yearLaterEnd(3),
    remark: '※空家特例',
  },
  {
    number: 13,
    text: '二次相続対策',
    timing: '期限はないが早め',
  },
];

const Comp = ({ show }) => {
  const dispatch = useDispatch();
  const formRef = useRef();
  const forms = useSelector((s) => s.forms);
  const config = useSelector((s) => s.config);
  const [activeStep, setActiveStep] = React.useState(0);
  const [answers, setAnswers] = React.useState([]);
  const [showResult, setShowResult] = React.useState(false);
  const [resultDocumentList, setResultDocumentList] = React.useState([]);
  const bodyRef = useRef(null);
  const close = () => {
    dispatch(actions.change('forms.setting.scheduleShowModal', false));
  };
  const handleWrightGoogleCalendar = () => {
    // Googleカレンダーに書き込む処理
  };

  const handleSubmit = (values) => {
    let disabledDocumentNumbers = [];
    let tempDocumetList = [];
    questionList.forEach((question, index) => {
      let currentAnswer = values.answers[index];
      if (question.type === 'choice' && currentAnswer?.value) {
        if (question.disabledDocumentNumbers[currentAnswer.value]) {
          disabledDocumentNumbers = disabledDocumentNumbers.concat(
            question.disabledDocumentNumbers[currentAnswer.value]
          );
        }
      }
    });
    let diedDate = values.answers[0].value;

    documentList.forEach((item) => {
      if (disabledDocumentNumbers.includes(item.number)) return;
      //item.timingが文字列だったら
      if (typeof item.timing === 'string') {
        tempDocumetList.push(item);
      } else {
        //item.timingが関数だったら
        tempDocumetList.push(
          Object.assign(item, { timing: item.timing(diedDate) })
        );
      }
    });
    setResultDocumentList(tempDocumetList);
    setAnswers(values.answers);
    bodyRef.current.scrollTop = 0;

    setShowResult(true);
  };
  const handleShowResult = () => {
    formRef.current.handleSubmit();
  };
  const handleHideResult = () => {
    setShowResult(false);
  };
  useEffect(() => {
    if (show) {
      setActiveStep(0);
      if (forms.standard.user?.decedent?.diedDate) {
        setAnswers([
          { disabled: false, value: forms.standard.user?.decedent?.diedDate },
        ]);
      }
    }
  }, [show, forms.standard.user.decedent.diedDate]);
  const schema = yup.object().shape({
    answers: yup.array(),
  });
  const getCurrentQuestionList = (activeStep, answers) => {
    let result = [];
    let disabledQuestionNumbers = [];
    let currentActiveStep = activeStep;
    questionList.forEach((question, index) => {
      if (disabledQuestionNumbers.includes(question.number)) {
        if (index === currentActiveStep) {
          currentActiveStep++;
        }
        return;
      }
      if (index > currentActiveStep) return;
      if (question.disabledQuestionNumbers) {
        let currentAnswer = answers[index];
        if (question.type === 'choice' && currentAnswer?.value) {
          if (question.disabledQuestionNumbers[currentAnswer.value]) {
            disabledQuestionNumbers = disabledQuestionNumbers.concat(
              question.disabledQuestionNumbers[currentAnswer.value]
            );
          }
        }
      }
      result.push(question);
    });
    setActiveStep(currentActiveStep);
    return result;
  };
  const moveScrollEndPosition = () => {
    bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  };

  return (
    <Modal show={show} onHide={close} className="change-plan">
      <Modal.Header closeButton>
        <Modal.Title>相続発生時の作業スケジュール</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ overflow: 'scroll', paddingBottom: 100 }}
        ref={bodyRef}
      >
        {showResult ? (
          <>
            <Button
              variant="success"
              className="mb-3"
              onClick={handleWrightGoogleCalendar}
            >
              以下の内容をGoogleカレンダーに書き込む
            </Button>
            <Table>
              <thead>
                <tr>
                  <th>完了</th>
                  <th>作業内容</th>
                  <th>作業時期</th>
                  <th>備考</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {resultDocumentList.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input form-control-lg"
                        style={{ marginTop: '-20px', marginLeft: '20px' }}
                      />
                    </td>
                    <td>{item.text}</td>
                    <td>{item.timing}</td>
                    <td>{item.remark}</td>
                    <th>
                      <Badge variant="primary" className="badge-pill">
                        詳細
                      </Badge>
                    </th>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        ) : (
          <Formik
            initialValues={{ answers }}
            validationSchema={schema}
            enableReinitialize
            onSubmit={handleSubmit}
            innerRef={formRef}
          >
            {(props) => {
              const handleAnswer = (field, value, index) => {
                props.setFieldValue(field, value);
                moveStep(index + 1);
              };
              const goNext = (e, index) => {
                e.stopPropagation();
                moveStep(index + 1);
              };
              const moveStep = (index) => {
                setActiveStep(index);
                if (index < questionList.length) {
                  props.setFieldValue(`answers[${index}]`, {});
                  moveScrollEndPosition();
                  return;
                }
              };
              let curretQuestionList = getCurrentQuestionList(
                activeStep,
                props.values.answers
              );
              return (
                <Stepper orientation="vertical">
                  {curretQuestionList.map((question, index) => (
                    <Step
                      variant="solid"
                      onClick={() => moveStep(question.step)}
                      key={question.step}
                      indicator={
                        <StepIndicator
                          variant={
                            activeStep < question.step ? 'soft' : 'solid'
                          }
                          color={
                            activeStep < question.step ? 'neutral' : 'primary'
                          }
                        >
                          {question.number}
                        </StepIndicator>
                      }
                    >
                      {question.text}
                      <div className="mt-3">
                        {activeStep === question.step ? (
                          <div>
                            {question.type === 'choice' ? (
                              <Radio
                                name={`answers[${question.step}].value`}
                                changeAction={(field, value) =>
                                  handleAnswer(field, value, question.step)
                                }
                                data={config.list.yesNo}
                              />
                            ) : (
                              <>
                                <Date
                                  viewMode="months"
                                  name={`answers[${question.step}].value`}
                                />
                                <Button
                                  className="my-2"
                                  onClick={(e) => goNext(e, question.step)}
                                  variant="primary"
                                >
                                  次へ
                                </Button>
                              </>
                            )}
                          </div>
                        ) : (
                          <div>
                            {question.type === 'choice' ? (
                              <>
                                {props.values.answers[question.step]?.value && (
                                  <>
                                    {props.values.answers[question.step]
                                      .value === '1'
                                      ? 'はい'
                                      : 'いいえ'}
                                  </>
                                )}
                              </>
                            ) : (
                              <>{props.values.answers[question.step].value}</>
                            )}
                          </div>
                        )}
                      </div>
                    </Step>
                  ))}
                </Stepper>
              );
            }}
          </Formik>
        )}
      </Modal.Body>
      <Modal.Footer>
        {showResult ? (
          <Button variant="outline-primary" onClick={handleHideResult}>
            条件入力に戻る
          </Button>
        ) : (
          <Button
            variant="primary"
            disabled={activeStep < questionList.length}
            onClick={handleShowResult}
          >
            作業スケジュールを確認する
          </Button>
        )}
        <Button variant="secondary" onClick={close}>
          閉じる
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default connect((s) => s)(Comp);
